<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-work-session-work-session-type-dialog-create
          v-if="$hasPermissionTo(['create work session types'])"
          @created="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in work session type name here"
          append-icon="search"
          label="Search work session type"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :loading="tableLoading"
      :items="workSessionTypes"
      :single-expand="true"
      show-expand
      :search="search"
    >
      <template v-slot:item="props">
        <tr>
          <td :class="props.isExpanded?'remove-bottom-border':'border-bottom'">
            <v-btn
              icon
              @click="props.expand(!props.isExpanded)"
            >
              <v-icon small> 
                {{ props.isExpanded ? 'fa-chevron-up':'fa-chevron-down' }} 
              </v-icon>
            </v-btn>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border':'border-bottom' ">
            <span class="font-weight-bold">
              {{ props.item.name }}
            </span>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border text-center':'border-bottom text-center' ">
            <span class="font-weight-bold ">
              <v-icon 
                v-if="props.item.is_active === 1" 
                color="green"
              >
                mdi-check-outline
              </v-icon>
              <v-icon 
                v-else 
                color="error"
              >
                mdi-close-outline
              </v-icon>
            </span>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border text-center':'border-bottom text-center' ">
            <span>
              {{ props.item.code ? props.item.code : '-' }}
            </span>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border':'border-bottom' ">
            <setup-work-session-work-session-type-dialog-edit
              v-if="$hasPermissionTo(['update work session types'])"
              :work-session-type="props.item"
              @updated="loadData"
            />
          </td> 
        </tr>
      </template>

      <template v-slot:expanded-item="{ headers,item }">
        <td :colspan="headers.length">
          <v-card
            class="elevation-5"
          >
            <v-tabs
              v-model="active"
              grow
              show-arrows
              color="hrissecondary"
            >
              <v-tab
                v-for="tab in tabItems"
                :key="tab.name"
              >
                {{ tab.name }}
              </v-tab>
            </v-tabs>

            <v-tabs-items 
              v-model="active"
            >
              <v-tab-item
                v-for="tab in tabItems"
                :key="tab.name"
              >
                <div 
                  v-if="tab.name === 'Schedule'"
                  class="mb-2 ml-4"
                >
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            Day
                          </th>
                          <th class="text-left">
                            Start Time
                          </th>
                          <th class="text-left">
                            End Time
                          </th>
                          <th class="text-left">
                            Lunch Range From
                          </th>
                          <th class="text-left">
                            Lunch Range To
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(workSession,index) in item.work_sessions"
                          :key="index"
                        >
                          <td>{{ getDay(workSession.day) }}</td>
                          <td>{{ $moment(workSession.start_time, 'hh:mm').format('hh:mm A') }}</td>
                          <td>{{ $moment(workSession.end_time, 'hh:mm').format('hh:mm A') }}</td>
                          <td>{{ workSession.lunch_range_from? $moment(workSession.lunch_range_from, 'hh:mm').format('hh:mm A') : 'N/A' }}</td>
                          <td>{{ workSession.lunch_range_to? $moment(workSession.lunch_range_to, 'hh:mm').format('hh:mm A'): 'N/A' }}</td>
                        </tr>
                      </tbody> 
                    </template>
                  </v-simple-table>
                </div>
                <div v-else-if="tab.name === 'Shift'">
                  <div class="mb-2 ml-4">
                    <setup-work-session-work-session-type-shift-container-view
                      :work-session-type="item"
                      @created="loadData"
                    />
                  </div>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupWorkSessionWorkSessionTypeDialogCreate: () => import('@/components/hris/setup/work-session/work-session-type/DialogCreate'),
      SetupWorkSessionWorkSessionTypeDialogEdit: () => import('@/components/hris/setup/work-session/work-session-type/DialogEdit'),
      SetupWorkSessionWorkSessionTypeShiftContainerView: () => import('@/components/hris/setup/work-session/work-session-type/shift/ContainerView'),
    },
    data () {
      return {
        search: '',
        headers: [
          {
            text: 'Work Session Types',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Active',
            align: 'center',
            value: 'is_active',
          },
          {
            text: 'Code',
            align: 'center',
            value: 'code',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        workSessionTypes: [],
        tableLoading: false,
        active: null,
        tabItems: [
          {
            name: 'Schedule',
          },
          {
            name: 'Shift',
          },
        ],
      }
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.tableLoading = true

        this.$api.workSessionTypes().list('').then(res => {
          this.workSessionTypes = _.orderBy(res.data, ['is_active', 'name'], ['desc', 'asc'])
          
          this.tableLoading = false
        })
      },

      getDay (day) {
        if (day === 1) {
          return 'Monday'
        } else if (day === 2) {
          return 'Tuesday'
        } else if (day === 3) {
          return 'Wednesday'
        } else if (day === 4) {
          return 'Thursday'
        } else if (day === 5) {
          return 'Friday'
        } else if (day === 6) {
          return 'Saturday'
        } else { return 'Sunday' }
      },
    },
  }
</script>

<style scoped>
.details {
  padding-left:85px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding-right:85px;
}

.remove-bottom-border {
  border-bottom: 0px !important
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important
}
</style>
